export default "__VITE_ASSET__DbhvoExl__"